import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("1234567890123456");
const blockSize = 16;

export const encryptString = (text: string) => {
  const iv = CryptoJS.lib.WordArray.random(blockSize);
  const encrypted = CryptoJS.AES.encrypt(text, key, { iv });
  return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
};

export const decryptString = (text: string) => {
  const base64Encoded = CryptoJS.enc.Base64.parse(text);
  const iv = base64Encoded.clone();
  iv.sigBytes = blockSize;
  iv.clamp();

  const ciphertext = base64Encoded.clone();
  ciphertext.words.splice(0, blockSize / 4);
  ciphertext.sigBytes -= blockSize;

  // @ts-ignore
  const decrypt = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC
  });
  return decrypt.toString(CryptoJS.enc.Utf8);
};
